import { render } from "./applyJobCard.vue?vue&type=template&id=cfc2653a&scoped=true"
import script from "./applyJobCard.vue?vue&type=script&lang=js"
export * from "./applyJobCard.vue?vue&type=script&lang=js"

import "./applyJobCard.vue?vue&type=style&index=0&id=cfc2653a&scoped=true&lang=less"

import exportComponent from "/root/.jenkins/workspace/embeddedJobWebProd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfc2653a"]])

export default __exports__